export default __webpack_public_path__ + "video-and-animation.77fa55a9.jpeg";